export default __webpack_public_path__ + "static/media/flaggh.9ac16154.svg";